module.exports = (original)-> ({React,FormGroup})->
  (props)=>
    return <div></div> if(!props.product) 
    {id,currency,country,location,credit_price,project,techarea,author,salesforce_ref,type,force_currency} = props.product
    extrafields = [
      <FormGroup label="Price in Credits" key="credit_price">
        <input type="text" className="form-control" id="credit_price" placeholder="0" value={credit_price || ""} onChange={(e)=> props.onUpdate(id,"credit_price",e.target.value)} />
      </FormGroup>

      <FormGroup label="Location" key="Location">
        <input type="text" className="form-control" id="location" placeholder="Location" value={location || ""} onChange={(e)=> props.onUpdate(id,"location",e.target.value)} />
      </FormGroup>

      <FormGroup label="Country" key="Country">
        <input type="text" className="form-control" id="country" placeholder="Country" value={country || ""} onChange={(e)=> props.onUpdate(id,"country",e.target.value)} />
      </FormGroup>

      <FormGroup label="Type" key="type">
        <input type="text" className="form-control" id="type" placeholder="type" value={type || ""} onChange={(e)=> props.onUpdate(id,"type",e.target.value)} />
      </FormGroup>

      <FormGroup label="Project" key="Project">
        <input type="text" className="form-control" id="project" placeholder="project" value={project || ""} onChange={(e)=> props.onUpdate(id,"project",e.target.value)} />
      </FormGroup>

      <FormGroup label="Tech Area" key="TechArea">
        <input type="text" className="form-control" id="techarea" placeholder="Techarea" value={techarea || ""} onChange={(e)=> props.onUpdate(id,"techarea",e.target.value)} />
      </FormGroup>

      <FormGroup label="Author" key="Author">
        <input type="text" className="form-control" id="author" placeholder="Author" value={author || ""} onChange={(e)=> props.onUpdate(id,"author",e.target.value)} />
      </FormGroup>

      <FormGroup label="Salesforce Id" key="salesforce_ref">
        <input type="text" className="form-control" id="salesforce_ref" value={salesforce_ref || "" } readOnly onChange={(e)=> props.onUpdate(id,"salesforce_ref",e.target.value)} />
      </FormGroup>

      <FormGroup label="Force Basket to Use Currency" key="force_currency" checkbox={true}>
        <input type="checkbox" id="force_currency" checked={force_currency || false} readOnly onChange={(e)=> props.onUpdate(id,"force_currency",e.target.checked)} />
      </FormGroup>
      
      <div className="row" key="notice">{if salesforce_ref?
        <div className="col-sm-9 col-sm-offset-3">
          <div className="alert alert-info">
            Please make any changes to this product in Salesforce.
          </div>
        </div>
      }</div>
    ]
    # below splices the new fields into the original form
    originalfields = original(props)
    offset = originalfields.length-2
    originalfields[...offset].concat extrafields,originalfields[offset...]